import { dateRangeFromISO, getDateRange } from "@app/lib/date-range";
import ChurnPage, { churnQuery } from "@app/pages/churn/churn-page";
import type { churnPage_Query } from "@app/queries/churnPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/churn")({
  loader: () =>
    loadQuery<churnPage_Query>(
      environment,
      churnQuery,
      { from: dateRangeFromISO(getDateRange()) ?? undefined },
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("Churn & retention"),
  component: ChurnRoute,
});

function ChurnRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading churn analysis</div>
      }
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Computing cohorts...</div>}
      >
        <ChurnPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
